(function () {
    angular
    .module('pgtocartaocobrancas', []);  
})();
